import { whiteLabelStore } from './WhiteLabelStore';
import { getMessageByKey, getPascalCaseMessageByKey } from '../Stores/LanguageStore';

export type CargoCharacteristicSource = 'Inherited' | 'Selected';

export type bookingStatus = 'BOOKED' | 'CANCELLED' | 'RESERVED' | 'EXPIRED_RESERVATION' | 'UNPAID' | 'EXPIRED_UNPAID';

export const bookingStatusOptions: { [key in bookingStatus]: string } = {
	BOOKED: 'Booked',
	CANCELLED: 'Cancelled',
	RESERVED: 'Reserved',
	EXPIRED_RESERVATION: 'Expired Reservation',
	UNPAID: 'Unpaid',
	EXPIRED_UNPAID: 'Expired Unpaid',
};

export type bookingType =
	| 'PASSENGER_ONLY'
	| 'VEHICLE'
	| 'VEHICLE_AND_PASSENGER'
	| 'TRAILER'
	| 'EVENT_BOOKING'
	| 'FREIGHT';

export type refundStatus = 'COMPLETED' | 'PENDING' | 'FAILED' | 'CANCELLED' | 'PENDING_MANUAL' | 'MANUALLY_COMPLETED';

export const refundStatusOptions: { [key in refundStatus]: string } = {
	COMPLETED: 'Completed refund',
	PENDING: 'Pending card refund',
	FAILED: 'Failed refund',
	CANCELLED: 'Cancelled refund',
	MANUALLY_COMPLETED: 'Manually refunded',
	PENDING_MANUAL: 'Pending manual refund',
};

export const bookingTypeOptions: { [key in bookingType]: string } = {
	PASSENGER_ONLY: getPascalCaseMessageByKey('passenger__name__label', 'Walk-on'),
	VEHICLE: getPascalCaseMessageByKey('vehicle__name__label', 'Vehicle'),
	VEHICLE_AND_PASSENGER: 'Vehicle and Passenger',
	TRAILER: 'Trailer',
	EVENT_BOOKING: 'Event Booking',
	FREIGHT: getPascalCaseMessageByKey('freight__name__label', 'Freight'),
};

export type communicationType = 'SMS' | 'EMAIL' | 'INFO_CHANGE' | 'BOOKING' | 'NOTE';

export const communicationTypeOptions: { [key in communicationType]: string } = {
	SMS: 'SMS',
	EMAIL: 'Email',
	INFO_CHANGE: 'Info Change',
	BOOKING: 'Booking',
	NOTE: 'Note',
};

export type cutoffType = 'EDIT' | 'CANCEL';

export const cutoffTypeOptions: { [key in cutoffType]: string } = {
	EDIT: 'Edit',
	CANCEL: 'Cancel',
};

export type refundType = 'CREDIT_REFUND' | 'BANK_REFUND' | 'ANY_REFUND';

export const refundTypeOptions: { [key in refundType]: string } = {
	CREDIT_REFUND: 'Credit Refund',
	BANK_REFUND: 'Bank Refund',
	ANY_REFUND: 'Any Refund',
};

export type feeApplicationLevel = 'Booking' | 'Transaction';

export const feeApplicationLevelOptions: { [key in feeApplicationLevel]: string } = {
	Booking: 'Per booking',
	Transaction: 'Per transaction',
};

export type defaultBookingType = 'PASSENGER' | 'CARGO' | 'FREIGHT';

export const defaultBookingTypeOptions: { [key in defaultBookingType]: string } = {
	PASSENGER: 'Passenger',
	CARGO: 'Cargo',
	FREIGHT: 'Freight',
};

export type discountType = 'GLOBAL' | 'PASSENGER' | 'VEHICLE' | 'TRAILER' | 'ADD_ON';

export const discountTypeOptions: { [key in discountType]: string } = {
	GLOBAL: 'Global',
	PASSENGER: 'Passenger',
	VEHICLE: 'Vehicle',
	TRAILER: 'Trailer',
	ADD_ON: 'Add on',
};

export type priceMode = 'FIXED' | 'PERCENTAGE';

export const priceModeOptions: { [key in priceMode]: string } = {
	FIXED: 'Fixed price',
	PERCENTAGE: 'Percentage discount',
};

export type feeType =
	| 'PHONE'
	| 'CANCELLATION'
	| 'ALTERATION'
	| 'STAFF_OVERRIDDEN'
	| 'OTHER'
	| 'CREDIT_CARD_SURCHARGE'
	| 'CHECK_IN_FORFEIT';

export const feeTypeOptions: { [key in feeType]: string } = {
	PHONE: 'Phone',
	CANCELLATION: 'Cancellation',
	ALTERATION: 'Alteration',
	STAFF_OVERRIDDEN: 'Staff Overridden',
	OTHER: 'Other',
	CREDIT_CARD_SURCHARGE: 'Credit Card Surcharge',
	CHECK_IN_FORFEIT: 'Check-In Forfeit Fee',
};

export type fontColour = 'DARK' | 'LIGHT';

export const fontColourOptions: { [key in fontColour]: string } = {
	DARK: 'Dark',
	LIGHT: 'Light',
};

export type locationType = 'NONE' | 'BOOKING_WIZARD' | 'CHECK_IN';

export const locationTypeOptions: { [key in locationType]: string } = {
	NONE: 'None',
	BOOKING_WIZARD: 'Booking Wizard',
	CHECK_IN: 'Check In',
};

export type measurementType = 'WEIGHT' | 'LENGTH';

export const measurementTypeOptions: { [key in measurementType]: string } = {
	WEIGHT: 'Weight',
	LENGTH: 'Length',
};

export type noteType = 'STAFF' | 'ALTERATION' | 'CANCELLATION' | 'COMMUNICATION' | 'USER';

export const noteTypeOptions: { [key in noteType]: string } = {
	STAFF: 'Staff',
	ALTERATION: 'Alteration',
	CANCELLATION: 'Cancellation',
	COMMUNICATION: 'Communication',
	USER: 'Customer',
};

export type smsDeliveryStatus =
	| 'DELIVERED'
	| 'UNDELIVERED'
	| 'EXPIRED'
	| 'REJECTED'
	| 'DELETED'
	| 'SENT'
	| 'FAILED'
	| 'SENDING'
	| 'QUEUED';

export const smsDeliveryStatusOptions: { [key in smsDeliveryStatus]: string } = {
	DELIVERED: 'Delivered',
	UNDELIVERED: 'Undelivered',
	EXPIRED: 'Expired',
	REJECTED: 'Rejected',
	DELETED: 'Deleted',
	SENT: 'Sent',
	FAILED: 'Failed',
	SENDING: 'Sending',
	QUEUED: 'Queued',
};

export type systemOfMeasurementType = 'METRIC' | 'IMPERIAL';

export const systemOfMeasurementTypeOptions: { [key in systemOfMeasurementType]: string } = {
	METRIC: 'Metric',
	IMPERIAL: 'Imperial',
};

export type timeFormat = 'TWENTY_FOUR_HOUR_TIME' | 'TWELVE_HOUR_TIME';

export const timeFormatOptions: { [key in timeFormat]: string } = {
	TWENTY_FOUR_HOUR_TIME: 'Twenty Four Hour Time',
	TWELVE_HOUR_TIME: 'Twelve Hour Time',
};

export type transactionStatus =
	| 'IN_PROGRESS'
	| 'COMPLETED'
	| 'FAILED'
	| 'ABANDONED'
	| 'INVOICED'
	| 'PENDING_INVOICE'
	| 'EFTPOS'
	| 'CASH'
	| 'PENDING_PAYMENT'
	| 'EXPIRED';

export const transactionStatusOptions: { [key in transactionStatus]: string } = {
	IN_PROGRESS: 'In Progress',
	COMPLETED: 'Completed',
	FAILED: 'Failed',
	ABANDONED: 'Abandoned',
	INVOICED: 'Invoiced',
	PENDING_INVOICE: 'Pending Invoice',
	EFTPOS: 'Eftpos',
	CASH: 'Cash',
	PENDING_PAYMENT: 'Pending Payment',
	EXPIRED: 'Expired',
};
export type tripDirectionTypes = 'DEPARTURE' | 'RETURN';

export type wizardModes = 'CREATE' | 'ALTERATION';

export const wizardModeOptions: { [key in wizardModes]: wizardModes } = {
	CREATE: 'CREATE',
	ALTERATION: 'ALTERATION',
};

export type bookingTransactionStatus = 'PAID' | 'CANCELLED' | 'INVOICED' | 'AWAITING' | 'UNPAID';

export type PassengerTypeKey = 'A' | 'B' | 'C' | 'D' | 'E' | 'F' | 'G' | 'H';

export function allPassengerTypeKeys(): PassengerTypeKey[] {
	return ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];
}

/**
 * The property names holding each passenger type's tickets on the booking wizard data, the
 * booking creation DTO and the check-in form state.
 *
 * Tenants configure their own passenger types — names, pricing, quantity, whether the type can
 * be the driver — but every configuration occupies the same eight fixed slots that
 * `PassengerTypeKey` enumerates. The property set is therefore statically known, and
 * `PassengerTypeStore.getWizardDataProperty` / `getBookingDtoProperty` map a key onto it.
 */
/**
 * Every passenger-ticket slot, as a value.
 *
 * <p>Listed rather than derived from `passengerTypeStore`, because code that has to touch *all* of
 * them — copying them, clearing them — must not depend on the store having loaded or on a passenger
 * type being enabled. A loop over the store that silently covers nothing is worse than no loop at
 * all: it leaves half the job done and looks like it worked.</p>
 */
export const passengerFields = [
	'adultTickets',
	'childTickets',
	'infantTickets',
	'passengerDTickets',
	'passengerETickets',
	'passengerFTickets',
	'passengerGTickets',
	'passengerHTickets',
] as const;

export type PassengerField = (typeof passengerFields)[number];

/**
 * The same eight slots as they are named on `BookingSummary`, where the first three carry a
 * `Passenger` infix. Resolved by `PassengerTypeStore.getBookingSummaryProperty`.
 */
export type BookingSummaryPassengerField =
	| 'adultPassengerTickets'
	| 'childPassengerTickets'
	| 'infantPassengerTickets'
	| 'passengerDTickets'
	| 'passengerETickets'
	| 'passengerFTickets'
	| 'passengerGTickets'
	| 'passengerHTickets';

export type cacheType =
	| 'ALL'
	| 'ADD_ONS'
	| 'CAPACITY'
	| 'CARGO_TYPES'
	| 'CONFIG_GENERAL'
	| 'CONFIG_THEME'
	| 'CLIENTSIDE_CONFIG'
	| 'DEFAULT_PRICES'
	| 'FERRIES'
	| 'FERRY_TRIPS'
	| 'LOCATIONS'
	| 'MEASUREMENTS'
	| 'PASSENGER_TYPES'
	| 'TOW_ON_TYPES'
	| 'USER_DISPLAY_NAMES'
	| 'WIDTHS'
	| 'APP_CONFIG'
	| 'LANGUAGES'
	| 'FREIGHT_TYPES'
	| 'FREIGHT_CATEGORIES'
	| 'FREIGHT_HANDLINGS'
	| 'FREIGHT_PRICE_RANGES'
	| 'DEPARTURE_TIME'
	| 'JOURNEY_ELEMENTS'
	| 'ROUTE_SEGMENTS'
	| 'ROUTE_STOPS'
	| 'STOPS'
	| 'ORGANISATIONS'
	| 'CHECK_IN_STATUSES'
	| 'LUNIO_PRICE_RECOMMENDATIONS'
	| 'LUNIO_TOKEN'
	| 'HELM'
	| 'PAYMENT_CONFIG'
	| 'EMAIL'
	| 'MARKETING'
	| 'PRICING'
	| 'ROUTE_TIMEZONES'
	| 'EVENT_CAPACITY'
	| 'SMS_CONFIG'
	| 'ANALYTICS_CONFIG'
	| 'BOOKING_CUTOFFS'
	| 'PASSENGER_CLASSES'
	| 'PERMISSIONS';

export const cacheTypeOptions: { [key in cacheType]: string } = {
	ALL: 'All caches',
	FERRY_TRIPS: 'Ferry trips',
	CAPACITY: 'Capacity',
	ADD_ONS: 'Add-ons',
	LOCATIONS: 'Locations',
	PASSENGER_TYPES: 'Passenger types',
	MEASUREMENTS: 'Measurements',
	CARGO_TYPES: 'Cargo types',
	TOW_ON_TYPES: 'Tow on types',
	FERRIES: 'Ferries',
	WIDTHS: 'Widths',
	CONFIG_THEME: 'Config theme',
	CONFIG_GENERAL: 'Config general',
	APP_CONFIG: 'App config',
	CLIENTSIDE_CONFIG: 'Clientside config',
	DEFAULT_PRICES: 'Default prices',
	USER_DISPLAY_NAMES: 'User display names',
	LANGUAGES: 'Languages',
	FREIGHT_TYPES: 'Freight types',
	FREIGHT_CATEGORIES: 'Freight categories',
	FREIGHT_HANDLINGS: 'Freight handlings',
	FREIGHT_PRICE_RANGES: 'Freight price ranges',
	DEPARTURE_TIME: 'Departure time',
	JOURNEY_ELEMENTS: 'Journey elements',
	ROUTE_SEGMENTS: 'Route segments',
	ROUTE_STOPS: 'Route stops',
	STOPS: 'Stops',
	ORGANISATIONS: 'Organisations',
	CHECK_IN_STATUSES: 'Check-in statuses',
	LUNIO_PRICE_RECOMMENDATIONS: 'Lunio price recommendations',
	LUNIO_TOKEN: 'Lunio token',
	HELM: 'Helm',
	PAYMENT_CONFIG: 'Payment config',
	EMAIL: 'Email & templates',
	MARKETING: 'Marketing',
	PRICING: 'Pricing',
	ROUTE_TIMEZONES: 'Route timezones',
	EVENT_CAPACITY: 'Event capacity',
	SMS_CONFIG: 'SMS config',
	ANALYTICS_CONFIG: 'Analytics config',
	BOOKING_CUTOFFS: 'Booking cutoffs',
	PASSENGER_CLASSES: 'Fare types',
	PERMISSIONS: 'Permission overrides',
};

export type priceAdjustmentType = 'NONE' | 'FIXED' | 'PERCENTAGE';

export const priceAdjustmentTypeOptions: { [key in priceAdjustmentType]: string } = {
	NONE: 'None',
	FIXED: 'Fixed',
	PERCENTAGE: 'Percentage',
};

export type discountCalculationType = 'PERCENTAGE' | 'FIXED' | 'CEILING';

export const discountCalculationTypeOptions: { [key in discountCalculationType]: string } = {
	PERCENTAGE: 'Percentage',
	FIXED: 'Fixed',
	CEILING: 'Ceiling',
};

export type EntitlementProductType = 'PASSENGER';

export const EntitlementProductTypeOptions: Record<EntitlementProductType, string> = {
	PASSENGER: 'Passenger',
};
